import { Colors } from '@unfold/theme';

import { TAlign, Variant } from './types';

export const DEFAULT_TEXT_ALIGN: TAlign = 'left';

export const DEFAULT_COLOR_PALETTE = {
  [Variant.H100]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.H200]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.H300]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.H400]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.H500]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.H600]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.H700]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.H800]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.H900]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.Code]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  [Variant.Paragraph]: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  a: {
    light: Colors.BLACK,
    dark: Colors.B100,
  },
  'a:hover': {
    light: Colors.BLACK,
    dark: Colors.B75,
  },
  'p>small': {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
  li: {
    light: Colors.BLACK,
    dark: Colors.G400,
  },
};

export const noWrapCss = `
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
